<template>
	<div class="home">
		<navbar :isHiddenlogin="true" ref="NavBar"></navbar>
		<step-bar :step="1"></step-bar>
		<!-- 商品选购 -->
		<div class="main-content">
			<!-- 左侧大图 -->
			<div class="main-left">
				<div class="main-left-box">
					<div class="main-left-seal"></div>
					<div class="main-left-title">招标采购人员专业能力评价</div>
					<div class="main-left-subtitle">
						<span
							style="width: min-content; display: inline-block;font-size: 18px;font-weight: normal;">新版</span>
						<span>2025·官方正版教材</span>
					</div>
				</div>
				<div class="main-cover-box">
					<img :src="setImg(selectedBook.icon)" class="main-cover" />
				</div>
			</div>
			<!-- 右侧商品选择区 -->
			<div class="main-right">
				<div class="tip">* 若您在教材学习过程中，有任何意见建议，欢迎在"招采人员专业能力评价系统"提交<a href="http://tpp.ctba.org.cn/opinion/index"
						target="_blank" class="link">意见建议</a>。我们将积极处理。</div>
				<div class="choose-title">选购商品
					<span class="hover-tooltip" @mouseenter="showCustomTooltip = true" @mouseleave="onTooltipLeave"
						@click.stop="showCustomTooltip = true">（教材及折扣说明）</span>
					<div v-if="showCustomTooltip" class="custom-tooltip-mask" @click="showCustomTooltip = false">
						<div class="custom-tooltip-content" @click.stop>
							<div style="font-weight:bold;font-size:18px;">教材说明：</div>
							<div style="font-size:14px;margin-bottom:20px;font-weight: normal;">
								1、招采人员专业能力评价辅导教材共4册：《招标采购专业理论与法律基础》、《招标采购专业实务》、《招标采购合同管理》、《招标采购项目管理》。<br />
								2、初级和中级测试科目数量不同（初级2科，中级4科），所用辅导教材相同。参测用户可按需选购。
							</div>
							<div style="font-weight:bold;font-size:18px">折扣说明：</div>
							<div style="font-size:14px;font-weight: normal;">
								1、单笔订单20册（或5套）内，无折扣。<br />
								2、单笔订单20册（或5套）-59册（或14套）及以内，折扣比例为9.5折。<br />
								3、单笔订单60册（或15套）-99册（或24套）及以内，折扣比例为9折。<br />
								4、单笔订单100册（或25套）及以上，折扣比例为8.8折。<br />
								5、一次性购买5套或20册及以上辅导教材的订单享受包邮 (新疆和西藏除外)<br />
								备注：上述“套"是指"全套4册"。
							</div>
						</div>
					</div>
				</div>
				<div class="book-list">
					<div class="book-row-title">套装:</div>
					<div class="books-container">
						<div class="book-row  book-row-flex" v-for="book in books.filter(b => Number(b.volumes) > 1)"
							:key="book.id" @click="selectBook(book)">
							<div class="book-row-item book-row">
								<div class="book-thumbs">
									<img :src="setImg(book.icon)" :alt="book.title" class="thumb"
										:class="{ selected: selectedBook.id === book.id }" />
								</div>
								<div class="book-title" :class="{ selected: selectedBook.id === book.id }">
									<div>{{ book.name }}</div>
									<span v-if="book.isSet" class="set-desc">
										{{ book.setText }}
									</span>
								</div>
								<div class="book-price">
									<span class="price">¥{{ book.price }}</span>
									<span class="origin" v-if="book.linePrice">¥{{ book.linePrice }}</span>
								</div>
								<div class="book-num">
									<!-- <span></span> -->
									<el-input-number v-model="book.defaultNum" :min="0" size="small"
										@change="onInput(book)" controls class="qty-input" :disabled="true" />
									<div class="outofstock">无货</div>
								</div>
							</div>
							<div class="book-dec">
								<span v-if="book.volumes == '4'" class="book-dec-flex">
									<span>含:《招标采购专业理论与法律基础》《招标采购专业实务》</span>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;《招标采购合同管理》《招标采购项目管理》</span>
								</span>
								<span v-if="book.volumes == '2'">含:《招标采购专业理论与法律基础》《招标采购专业实务》</span>
							</div>
						</div>
					</div>
				</div>
				<div class="books-line"></div>
				<div class="book-list">
					<div class="book-row-title">单册:</div>
					<div class="books-container">
						<div class="book-row" v-for="book in books.filter(b => Number(b.volumes) <= 1)" :key="book.id"
							@click="selectBook(book)">
							<div class="book-thumbs">
								<img :src="setImg(book.icon)" :alt="book.title" class="thumb"
									:class="{ selected: selectedBook.id === book.id }" />
							</div>
							<div class="book-title book-margin-left" :class="{ selected: selectedBook.id === book.id }">
								<div>{{ book.name }}<span v-if="book.remark" class="set-desc">{{ book.remark }}</span></div>
								<span v-if="book.isSet" class="set-desc">
									{{ book.setText }}
								</span>
								<!-- <span v-if="book.remark" class="set-desc">{{ book.remark }}</span> -->

							</div>
							<div class="book-price">
								<span class="price">¥{{ book.price }}</span>
								<span class="origin" v-if="book.linePrice">¥{{ book.linePrice }}</span>
							</div>
							<div class="book-num">
								<!-- <span></span> -->
								<el-input-number v-model="book.defaultNum" :min="0" size="small" @change="onInput(book)"
									controls class="qty-input"
									:disabled="(book.id !== 'e77e9a1a8a3f31434792f7fe55f49359' && book.id !== '37d70e4292a63a6407b726086788499d') ? true : false" />
								<div class="outofstock"
									v-if="(book.id !== 'e77e9a1a8a3f31434792f7fe55f49359' && book.id !== '37d70e4292a63a6407b726086788499d') ? true : false">
									无货</div>
							</div>
						</div>
					</div>
				</div>
				<div class="total-continaer">
					<div class="total-bar">
						已选购商品总价：<span class="total">¥{{ totalPrice.toFixed(2) }}</span>
						<span class="total-origin" v-if="originTotal > totalPrice">
							<span class="books-origin">
								<em>(原价 : <i>￥{{ originTotal }}</i>)</em>
							</span>
						</span>
					</div>
					<el-button type="primary" class="buy-btn" @click="buyNow">立即购买</el-button>
				</div>
			</div>
		</div>
		<!-- 招标采购人员专业能力评价 -->
		<div class="capability-evaluation">
			<div class="capability-bg">
				<div class="capability-title">招标采购人员专业能力评价</div>
				<div class="capability-core">
					<span>依法合规</span>
					<span>客观公正</span>
					<span>科学组织</span>
					<span>专业评价</span>
				</div>
				<div class="capability-desc">
					为贯彻落实国务院办公厅《关于创新完善体制机制推动招标投标市场规范健康发展的指导意见》（国办发〔2024〕21号）和《中华人民共和国职业分类大典（2022年版）》相关要求，建立招标采购专业人才培养机制，加快提升招标采购行业专业服务能力水平，规范招标采购从业人员职业行为，稳固发展招标采购行业人才队伍，进一步完善招标采购专业人员能力评价工作，中国招标投标协会开展了招标采购人员专业能力评价。
				</div>
			</div>
		</div>
		<div class="organizational-box">
			<!-- 组织单位 -->
			<div class="organizational-unit">
				<div class="org-unit-container">
					<div class="org-unit-left">
						<div class="unit-title">组织单位</div>
						<div class="org-unit-row">
							<img src="@/assets/images/home/ctba-logo.png" alt="CTBA" class="org-unit-logo" />
							<span class="org-unit-name">中国招标投标协会</span>
						</div>
						<ul class="org-unit-desc">
							<!-- <div class="org-unit-desc-title"></div> -->
							<div>组建招采人员专业能力评价专家指导委员会，负责指导招采人员专业能力评价工作。</div>
							<li>负责组织实施招采人员专业能力评价工作，制定评价办法、评价细则，组织编制测试科目大纲和辅导教材，组织评价测试与评审、从业登记及继续教育；负责建设维护招采人员专业能力评价信息系统。
							</li>
						</ul>
					</div>
					<div class="org-unit-right">
						<div class="unit-title" style="margin-bottom: 50px;">能力评价制度政策</div>
						<div class="org-policy-row">
							<!-- <div class="org-policy-arrow arrow-left" @click="prevPolicyImg"></div> -->
							<div class="org-policy-item" v-for="(item, i) in currentPolicyGroup" :key="i"
								@click="goPDF(item.src)">
								<div class="org-policy-imgs">
									<div class="org-policy-img-group">
										<img :src="item.img" class="org-policy-img" />
									</div>
								</div>
								<div class="org-policy-name">{{ item.title }}</div>
								<div class="org-policy-no">{{ item.no }}</div>
							</div>
							<!-- <div class="org-policy-arrow arrow-right" @click="nextPolicyImg"></div> -->
						</div>


					</div>
				</div>
			</div>
		</div>
		<!-- 专业能力评价等级 -->
		<div class="certificate-box">
			<div class="certificate-mian">
				<div class="unit-title">专业能力评价等级</div>
				<div class="certificate-list">
					<div class="certificate-item" v-for="(item, idx) in certificateList" :key="idx">
						<div class="certificate-info">
							<img :src="item.icon" class="certificate-icon" />
							<div class="certificate-texts">
								<div class="certificate-level">评价等级：{{ item.level }}</div>
								<div>评价方式：{{ item.method }}</div>
							</div>
						</div>
						<!-- <img :src="item.img" class="certificate-img" /> -->
						<!-- <div class="certificate-sample">（证书样例）</div> -->
					</div>
				</div>
			</div>
		</div>
		<!-- 测试流程 -->
		<div class="test-process">
			<div class="test-process-container">
				<div class="test-tabs">
					<div v-for="tab in testTabs" :key="tab.key"
						:class="['test-tab', { active: currentTestTab === tab.key }]" @click="currentTestTab = tab.key">
						<div>{{ tab.label }}</div>
					</div>
				</div>
				<div class="test-tab-subtitle"><span v-for="tab in testTabs" :key="tab.key">{{ tab.subtitle }}</span>
				</div>
				<div class="test-tab-content">
					<div class="test-tab-steps">
						<template v-for="(step, idx) in currentTabData.steps">
							<div :key="'step-' + idx" class="test-step">
								<div class="test-step-circle">
									<img :src="step.icon" alt="">
								</div>
								<div class="test-step-label">{{ step.label }}</div>
							</div>
							<img v-if="idx !== currentTabData.steps.length - 1" :key="'arrow-' + idx"
								src="@/assets/images/home/icon3.png" class="test-step-arrow" />
						</template>
						<!-- <div v-if="currentTestTab === 'senior'" class="test-senior-tip">
							各等级能力评价流程以官网发布的评价细则为准。
						</div> -->
					</div>
					<div class="test-tab-panels" :class="currentTestTab">
						<div class="test-panel test-panel-left">
							<div class="test-panel-title">报名条件</div>
							<div class="test-panel-content">
								<div v-for="(line, idx) in currentTabData.requirements" :key="idx" v-html="line"></div>
								<div class="test-panel-img">
									<img height="100px" src="@/assets/images/home/icon5.png" alt="">
									<img height="100px" src="@/assets/images/home/icon6.png" alt="">
								</div>
							</div>
						</div>
						<div class="test-panel test-panel-right" v-if="currentTabData.booksImg">
							<div class="test-panel-title">测试科目</div>
							<div class="test-panel-content test-subject">
								<div v-for="(subject, idx) in currentTabData.subjects" :key="idx" v-html="subject">
								</div>
								<img :src="currentTabData.booksImg" class="test-books-img" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 浮窗 -->
		<!-- <div class="floatinz-window" v-if="isfloatinz">
			<div class="floatinz-window-container">
				<a href="" target="_blank"> 
					<img src="@/assets/images/home/floatinz-window.png" alt="" />
				</a> 
				<div class="floatinz-close" @click.stop="isfloatinz = false">
					<img src="@/assets/images/home/floatinz-close.png" alt="">
				</div>
			</div>
		</div> -->
		<!-- 教材简介 -->
		<div class="textbook-introduction">
			<div class="unit-title">能力评价辅导教材简介</div>
			<div class="textbook-item" v-for="(item, idx) in textbookList" :key="idx">
				<img :src="item.img" class="textbook-img" />
				<div class="textbook-info">
					<div class="textbook-title">{{ item.title }}</div>
					<div class="textbook-desc">{{ item.desc }}</div>
				</div>
			</div>
		</div>
		<!-- 电话 -->
		<div class="fixed fixed-tel-lmjj" @mouseenter="showPopup = true" @mouseleave="showPopup = false">
			<div class="tel">
				<img src="../../assets/images/home/tel.png" alt="">
				<p>电话咨询</p>
			</div>
		</div>
		<div id="popup" :class="{ 'popup-visible': showPopup }">
			<div class="products-content-right-btn">
				<div class="products-content-ph">
					<p style="margin: 0;">010-88484118-815</p>
					<p style="margin: 0;">010-88484118-855</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import navbar from '@/components/nav.vue'
import stepBar from '@/components/step-bar.vue'
import { getBooksList } from '@/api/api'
import Cookies from 'js-cookie'
export default {
	name: "index",
	components: {
		navbar,
		stepBar
	},
	data() {
		return {
			step: 1,
			books: [],
			selectedBook: {},
			totalPrice: 0,
			originTotal: 0,
			policyShowCount: 2, // 全局控制显示数量
			isfloatinz: true,
			policyImgs: [
				{
					img: require('@/assets/images/home/pdf1.svg'),
					title: '《招标采购人员专业能力评价办法》',
					no: '中招协行发〔2025〕30号',
					src: '/assets/file/招标采购人员专业能力评价办法.pdf'
				},
				{
					img: require('@/assets/images/home/pdf2.svg'),
					title: '《招标采购人员专业能力评价初级测试细则》',
					no: '中招协行发〔2025〕30号',
					src: '/assets/file/招标采购人员专业能力评价初级测试细则.pdf'
				},
				// 后续可继续添加
			],
			policyIndex: 0,
			certificateList: [
				{
					icon: require('@/assets/images/home/certificate-icon1.png'),
					level: '初级',
					method: '应答测试评价',
					img: require('@/assets/images/home/certificate1.png'),
				},
				{
					icon: require('@/assets/images/home/certificate-icon2.png'),
					level: '中级',
					method: '应答测试评价',
					img: require('@/assets/images/home/certificate2.png'),
				},
				{
					icon: require('@/assets/images/home/certificate-icon3.png'),
					level: '高级',
					method: '专业成果业绩评审评价',
					img: require('@/assets/images/home/certificate3.png'),
				}
			],
			testTabs: [
				{ key: 'primary', label: '初级测试流程', subtitle: '应答测试', },
				{ key: 'intermediate', label: '中级测试流程', subtitle: '应答测试', },
				{ key: 'senior', label: '高级评审流程', subtitle: '专业成果业绩评审', }
			],
			currentTestTab: 'primary',
			testProcessData: {
				primary: {
					title: '初级测试流程',
					steps: [
						{ label: '实名认证', icon: require('@/assets/images/home/step1.png') },
						{ label: '报名缴费', icon: require('@/assets/images/home/step2.png') },
						{ label: '模拟测试', icon: require('@/assets/images/home/step3.png') },
						{ label: '正式测试', icon: require('@/assets/images/home/step4.png') },
						{ label: '成绩公示', icon: require('@/assets/images/home/step5.png') },
						{ label: '获得证书', icon: require('@/assets/images/home/step6.png') },
					],
					requirements: [
						'<div class="origin">大学专科及以上学历或同等学历。</div>',
						'<span style="font-size:13px;padding-left: 16px;">(请提前准备2寸白底免冠电子版照片，毕业证书电子版)</span>',
					],
					subjects: [
						'<div class="origin">《招标采购专业理论与法律基础》</div>',
						'<div class="origin">《招标采购专业实务》</div>'
					],
					booksImg: require('@/assets/images/home/7.png')
				},
				intermediate: {
					title: '中级测试流程',
					steps: [
						{ label: '实名认证', icon: require('@/assets/images/home/step1.png') },
						{ label: '报名缴费', icon: require('@/assets/images/home/step2.png') },
						{ label: '模拟测试', icon: require('@/assets/images/home/step3.png') },
						{ label: '正式测试', icon: require('@/assets/images/home/step4.png') },
						{ label: '成绩公示', icon: require('@/assets/images/home/step5.png') },
						{ label: '获得证书', icon: require('@/assets/images/home/step6.png') },
					],
					requirements: [
						'<span style="font-size:14px;padding-left: 16px;margin-bottom: 5px;display: inline-block;">应满足以下条件之一：</span>',
						'<div class="text-container origin-text">1. 取得招采人员专业能力评价初级证书，满足从业登记与继续教育要求，申报前连续从事招标采购工作满4年；</div>',
						'<div class="text-container origin-text">2. 大学本科及以上学历，申报前连续从事招标采购工作满5年；</div>',
						'<div class="text-container origin-text">3. 具有人社部认可的相关职业资格证书，或中级及以上相关专业技术职称，申报前连续从事招标采购工作满3年。</div>',
						'<span style="font-size:13px;padding-left: 12px;">（请提前准备电子寸照、毕业证书电子版）</span>'
					],
					subjects: [
						'<div class="text-container origin">《招标采购专业理论与法律基础》</div>',
						'<div class="text-container origin">《招标采购专业实务》</div>',
						'<div class="text-container origin">《招标采购项目管理》</div>',
						'<div class="text-container origin">《招标采购合同管理》</div>'
					],
					booksImg: require('@/assets/images/home/test-books.png')
				},
				senior: {
					title: '高级评审流程',
					subtitle: '专业成果业绩评审',
					steps: [
						{ label: '实名认证', icon: require('@/assets/images/home/step1.png') },
						{ label: '报名缴费', icon: require('@/assets/images/home/step2.png') },
						{ label: '业绩评审', icon: require('@/assets/images/home/step7.png') },
						{ label: '信息公示', icon: require('@/assets/images/home/step5.png') },
						{ label: '获得证书', icon: require('@/assets/images/home/step6.png') },
					],
					requirements: [
						'<span style="font-size:14px;padding-left: 16px;margin-bottom: 5px;display: inline-block;">应满足以下条件之一：</span>',
						'<div class="text-container origin-text">1. 取得招采人员专业能力评价中级证书，满足从业登记及继续教育要求，申报前连续从事招标采购工作满5年；</div>',
						'<div class="text-container origin-text">2. 具有人社部认可的高级专业技术职称，申报前累计从事招标采购工作满8年。</div>',
						'<span style="font-size:13px;padding-left: 12px;">（请提前准备电子寸照、毕业证书电子版）</span>'
					],
					subjects: [

					],
					// booksImg: require('@/assets/images/home/test-books.png')
				}
			},
			textbookList: [
				{
					img: require('@/assets/images/home/3.png'),
					title: "《招标采购专业理论与法律基础》",
					desc: '《招标采购专业理论与法律基础》是招标采购人员专业能力评价测试的基础理论科目，系统介绍了招标采购人员所应具备的经济学、管理学专业理论以及法律基础知识和招标采购工作所涉及的常用法律法规。其中，经济学理论主要包括市场结构与定价原理、博弈论、委托代理理论交易成本理论、公共选择理论等；管理学理论主要包括战略管理、需求与计划管理、供应链管理等，特别对绿色供应链采购和供应链金融做了专门的介绍；法律基础包括相关法律基础知识、招标采购法律制度体系以及与招标采购相关的法律法规。'
				},
				{
					img: require('@/assets/images/home/4.png'),
					title: "《招标采购专业实务》",
					desc: '《招标采购专业实务》是招标采购人员专业能力评价的核心科目。本科目辅导教材立足提升招标采购人员专业实务能力水平，按照测评大纲要求，通过系统融合解析招标采购基础理论、法律制度与最新政策要求、技术标准、示范文本和实践案例分析，系统介绍了策划与管控招标采购项目需求方案、编制招标采购文件、设置投标资格能力条件、评标办法与要素标准，组织开标、评标、定标、订立履行合同等交易全过程实务操作要领；深度讲解了电子招标投标全流程交易规则特点和数字化发展趋势；介绍了非招标的采购方式和企业集中釆购组织形式；阐述了行政执法监督制度与违法责任，争议解决途径方式；简述了政府采购和外资项目招标采购交易制度规则。期望本教材能够适应各行业招标采购岗位人员学习研究、实践操作和响应测评的热切需要，有效提升招标采购专业实务能力水平。'
				},
				{
					img: require('@/assets/images/home/5.png'),
					title: "《招标采购合同管理》",
					desc: '《招标采购合同管理》是招标采购人员专业能力评价测试的专业技术科目，系统阐述了招标采购合同的法律基础与合同管理实务,全面介绍了建设工程合同、国内外买卖合同、服务合同，以及其他相关合同的主要内容，包括合同文本、条款起草、合同签订与履行、风险防范、争议解决等方面合同管理要义。本书可以作为招标采购人员专业能力评价测试专家命题和考生复习备考的指定用书也可以作为招标采购相关从业人员日常工作的参考用书，还可以作为高等院校相关专业教师的教学研究用书。'
				},
				{
					img: require('@/assets/images/home/6.png'),
					title: "《招标采购项目管理》",
					desc: '《招标采购项目管理》是招标采购人员专业能力评价测试的专业理论科目，系统介绍了项目管理的基本原理、任务及工具，以及工程建设项目过程管理、工程建设项目要素管理、货物与服务项目管理的主要内容，同时以招标采购活动为项目管理对象，系统阐述了招标采购项目化管理的特点、过程，以及招标采购的各阶段管理、风险管理、数字化管理、绩效评价等内容。本书可以作为招标采购人员专业能力评价测试专家命题和考生复习备考的指定用书，也可以作为招标采购相关从业人员日常工作的参考用书，还可以作为高等院校相关专业教师的教学研究用书。'
				}
			],
			showPopup: false,
			showCustomTooltip: false,

		}
	},
	computed: {
		currentPolicyGroup() {
			const imgs = this.policyImgs
			const len = imgs.length
			const count = this.policyShowCount
			const start = this.policyIndex
			// 取出count个，循环
			return Array.from({ length: count }, (_, i) => imgs[(start + i) % len])
		},
		currentTabData() {
			return this.testProcessData[this.currentTestTab];
		}
	},
	methods: {
		//设置图片路径
		setImg(idx) {
			console.log(idx)
			if (!idx) return;
			return require(`@/assets/images/home/${idx}.png`)
		},
		//获取书籍列表
		getList() {
			getBooksList().then((res) => {
				if (res.code == 200) {
					this.books = res.data.map(item => ({
						...item,
						defaultNum: 0,
					}))
					this.selectedBook = this.books[0];
					this.books.map(item => {
						if (Number(item.volumes) > 1) {
							console.log(item)
						}
					})
					// 新增：同步 localStorage 中的数量
					const goodsStr = window.localStorage.getItem('goods');
					if (goodsStr) {
						try {
							const goodsArr = JSON.parse(goodsStr);
							goodsArr.forEach(good => {
								const book = this.books.find(b => b.id === good.goodsId);
								if (book) {
									book.defaultNum = parseInt(good.quantity) || 0;
								}
							});
						} catch (e) {
							// 解析失败可忽略
						}
					}
					this.calcTotal();
				}

			})
		},
		prevPolicyImg() {
			const len = this.policyImgs.length
			this.policyIndex = (this.policyIndex - 1 + len) % len
		},
		nextPolicyImg() {
			const len = this.policyImgs.length
			this.policyIndex = (this.policyIndex + 1) % len
		},
		selectBook(book) {
			this.selectedBook = book
		},
		onInput(book) {
			// 只允许0及以上的整数
			let val = parseInt(book.defaultNum)
			if (isNaN(val) || val < 0) val = 0
			book.defaultNum = val
			this.calcTotal()
		},
		calcTotal() {
			let total = 0
			let origin = 0
			let totalBooks = 0
			this.books.forEach(b => {
				totalBooks += (b.volumes || 1) * b.defaultNum
				total += b.price * b.defaultNum
				if (b.linePrice) {
					origin += b.linePrice * b.defaultNum
				} else {
					origin += b.price * b.defaultNum
				}
			})

			let discount = 1;
			if (totalBooks >= 100) {
				discount = 0.88;
			} else if (totalBooks >= 60) {
				discount = 0.9;
			} else if (totalBooks >= 20) {
				discount = 0.95;
			}

			this.totalPrice = total * discount
			this.originTotal = origin;
			Cookies.set('originTotal', origin);
		},
		buyNow() {
			// 直接进入下单流程，无需弹窗
			if (Cookies.get('Authorization')) {
				const selectedGoods = this.books
					.filter(book => book.defaultNum > 0)
					.map(book => ({
						goodsId: book.id,
						quantity: book.defaultNum.toString()
					}));

				if (selectedGoods.length === 0) {
					this.$message.warning('请至少选择一本图书');
					return;
				}
				window.localStorage.setItem('goods', JSON.stringify(selectedGoods));
				this.$router.push({ path: '/receiving-address' });
			} else {
				this.$refs.NavBar.openLogin();
			}
		},
		goPDF(src) {
			window.open(src, '_blank')
		},
		onTooltipLeave() {
			// 延迟关闭，避免鼠标快速移入弹窗内容时闪烁
			setTimeout(() => {
				if (!document.querySelector('.custom-tooltip-content:hover') && this.showCustomTooltip) {
					this.showCustomTooltip = false;
				}
			}, 200);
		},
	},
	mounted() {
		this.calcTotal();
		this.getList();
	}
}
</script>
<style scoped>
.home {
	background: #fff;
	min-height: 100vh;
	padding-bottom: 40px;
}

.main-content {
	display: flex;
	width: var(--main-width);
	margin: 60px auto auto auto;
	background: #fff;
}

.main-left {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 20px 15px 30px 15px;
	background-image: url('@/assets/images/home/book-bg.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	flex-direction: column;
	box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
	/* border-radius: 8px; */
	height: max-content;
	width: 300px;
}

.main-left-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;

}

.main-left-seal {
	width: 120px;
	height: 120px;
	background-image: url('@/assets/images/home/seal.png');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	position: absolute;
	top: -80px;
	left: -66px;
}

.main-left-subtitle {
	font-size: 24px;
	font-weight: bold;
	color: #FFE900;
	margin: 0px auto 10px auto;
	display: flex;
	align-items: center;
	gap: 10px;
}

.main-left-title {
	font-size: 14px;
	color: #fff;
	background-color: #1F5AC7;
	padding: 3px 15px;
	border-radius: 20px;
	margin-left: 70px;
}

.main-cover-box {
	display: flex;
	align-items: center;
	justify-content: end;
	height: 100%;
}

.main-cover {
	height: 380px;
	padding: 3px;
	object-fit: contain;
	box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
	/* border-radius: 8px; */
}

.main-right {
	flex: 1.8;
	padding: 0px 0px 30px 40px;
}

.tip {
	font-size: 14px;
	color: #656565;
	margin-bottom: 10px;
	font-weight: 550;
}

.link {
	color: #2765D5;
	text-decoration: underline;
}

.choose-title {
	font-size: 20px;
	font-weight: bold;
	margin: 15px 0 25px 0;
}

.choose-title span {
	color: #D12237;
	font-weight: normal;
	cursor: help;
}

.book-thumbs {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 8px;
}

.thumb {
	/* width: 40px; */
	height: 45px;
	object-fit: cover;
	border: 1px solid #eee;
	border-radius: 4px;
	cursor: pointer;
	transition: border 0.2s;
}

.thumb.selected {
	border: 1px solid #1976ff;
}

.book-list {
	margin-top: 10px;
	display: flex;
	flex-direction: row;
}

.books-container {
	flex: 1;
	position: relative;
}

.books-line {
	width: 405px;
	height: 1px;
	border-bottom: 1px dashed #919191;
	display: block;
	margin: 10px 0 20px 85px;

}

@media (max-width: 1300px) {
	.books-container {
		padding-right: 45px;
	}
}

.book-row-title {
	width: max-content;
	min-width: 100px;
	font-size: 20px;
	color: #6F6F6F;
	padding-top: 10px;
}

.book-row {
	display: flex;
	align-items: center;
	/* border-bottom: 1px solid #f0f0f0; */
	cursor: pointer;
	margin-bottom: 10px;
}

.book-row-flex {
	display: flex;
	flex-direction: column;
}

.book-row-item {
	width: 100%;
}

.book-dec {
	text-align: left;
	font-size: 13px;
	width: 100%;
	color: #919191;
	margin-left: 85px;
	margin-top: -12px;
}

.book-dec-flex {
	display: flex;
	flex-direction: column;
}

.book-row-flex:nth-child(1) .book-title {
	margin-left: 8px;
}

.book-row-flex:nth-child(2) .book-title {
	margin-left: 8px;
}

.book-title {
	flex: 2;
	font-size: 16px;
	color: #222;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.book-margin-left {
	margin-left: 5px;
}

.book-title.selected {
	color: #1976ff;
}

.set-desc {
	font-size: 13px;
	color: #888;
	margin-left: 6px;
}

.book-price {
	flex: .5;
	font-size: 16px;
	color: #CC0000;
	font-weight: bold;
	margin-right: 65px;
	min-width: 100px;
	max-width: 100px;
	text-align: right;
}

.book-num {
	align-items: center;
	display: flex;
	position: relative;
}

.book-num .outofstock {
	position: absolute;
	right: -52px;
	top: 4px;
	width: 48px;
	height: 25px;
	line-height: 25px;
	text-align: center;
	background: #888b94;
	color: #fff;
	border-radius: 4px;
	font-size: 12px;
	z-index: 1;
	cursor: not-allowed;
}

.book-num span {
	display: inline-block;
	background-image: url('@/assets/images/home/x.png');
	background-repeat: no-repeat;
	background-size: 20px;
	width: 20px;
	height: 20px;
}

.book-price .origin {
	font-size: 13px;
	color: #bbb;
	text-decoration: line-through;
	margin-left: 8px;
	font-weight: normal;
}

.qty-input {
	width: 100px;
	position: relative;
}

.qty-input ::v-deep .el-input__inner {
	-moz-appearance: textfield;
	text-align: center;
	padding-left: 30px;
	padding-right: 30px;
}

/* 
.qty-input ::v-deep input::-webkit-outer-spin-button,
.qty-input ::v-deep input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
} */

.qty-input ::v-deep .el-input__suffix {
	right: 2px !important;
	left: auto !important;
	display: flex;
	align-items: center;
	height: 100%;
}

.total-continaer {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	gap: 46px;
}

.total-bar {
	margin: 10px 0 0px 0;
	font-size: 20px;
	color: #6F6F6F;
	text-align: right;
}

.total {
	color: #CC0000;
	font-size: 22px;
	margin: 0 8px;
}

.total-bar .books-origin {
	margin-left: 8px;
	font-weight: normal;
}

.total-bar .books-origin em {
	font-size: 14px;
}

.total-bar .books-origin i {
	text-decoration: line-through;
}

.total-origin {
	font-size: 15px;
	color: #6F6F6F;
}

.buy-btn {
	width: 220px;
	height: 44px;
	font-size: 18px;
	background: #2765D5;
	border-radius: 8px;
	font-weight: bold;
	display: block;
}

/* 新增能力评价区块样式 */
.capability-evaluation {
	margin-top: 40px;
	margin-bottom: 0;
}

.capability-bg {
	background: url('@/assets/images/home/capability-bg.png') no-repeat;
	background-size: cover;
	padding: 48px 32px 100px 32px;
	color: #fff;
	text-align: center;
	margin: 0 auto;
	/* max-width: calc(var(--main-width) - 64px); */
	position: relative;
	overflow: hidden;
}

.capability-title {
	font-size: 48px;
	font-weight: bold;
	letter-spacing: 2px;
	margin: 50px auto 10px auto;
}

.capability-core {
	display: flex;
	justify-content: center;
	gap: 48px;
	font-size: 22px;
	font-weight: 500;
	margin-bottom: 32px;
	align-items: center;
	margin-top: 30px;
}

.capability-core span {
	background-color: #2D8FE4;
	color: #fff;
	text-align: center;
	font-size: 22px;
	padding: 1px 20px;
	border-radius: 5px;
}

.capability-desc {
	font-size: 16px;
	line-height: 2;
	max-width: var(--main-width);
	margin: 0 auto;
	text-align: left;
	padding: 24px 32px;
	border-radius: 8px;
	text-align: justify;
	text-indent: 32px;
}

.organizational-box {
	/* background: #F8F8F8; */
	position: relative;
	overflow: hidden;
	margin-bottom: 30px;
	background-image: url('@/assets/images/home/bg-1.png');
	background-size: 100% 100%;
	padding-bottom: 30px;
}

/* 组织单位区块样式 */
.organizational-unit {
	border-radius: 12px;
	margin: 0px auto 0 auto;
	max-width: var(--main-width);
	padding: 45px 32px 30px 32px;
}

.org-unit-container {}

.org-unit-left,
.org-unit-right {
	flex: 1;
}

.unit-title {
	font-size: 22px;
	font-weight: bold;
	color: #222;
	text-align: center;
	background-image: url('@/assets/images/home/btn-bg.png');
	background-repeat: no-repeat;
	color: #fff;
	background-size: 100% 100%;
	height: 43px;
	width: 250px;
	line-height: 43px;
	margin: 0 auto;
	margin-bottom: var(--title-top);
}

.org-unit-row {
	display: flex;
	align-items: center;
	gap: 5px;
	margin-bottom: 10px;
	justify-content: center;
}

.org-unit-logo {
	height: 60px;
}

.org-unit-name {
	font-weight: 500;
	font-size: 20px;
	color: #373737;
}

.org-unit-desc {
	margin-left: 0;
	padding-left: 18px;
	/* list-style: disc; */
	font-size: 16px;
	color: #4D4D4D;
	text-align: left;
	width: 70%;
	margin: 0 auto;
	text-indent: 32px;
}

.org-unit-desc div {
	margin-bottom: 5px;
}

.org-unit-desc-title {
	margin-bottom: 10px;
}

.org-unit-desc li {
	margin-bottom: var(--title-top);
	line-height: 1.8;
}

.org-unit-right {
	text-align: left;
}

.org-policy-row {
	display: flex;
	gap: 100px;
	align-items: center;
	justify-content: center;
	margin: 0px auto 0px auto;
}

.org-policy-item {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.org-policy-name {
	font-size: 16px;
	color: #4D4D4D;
}

.org-policy-no {
	font-size: 14px;
	color: #A0A0A0;
	margin-top: 5px;
}

.org-policy-imgs {
	display: flex;
	gap: 18px;
	margin-bottom: 18px;
	align-items: center;
	justify-content: center;
}

.org-policy-img-group {
	display: flex;
	gap: 32px;
	align-items: center;
	justify-content: center;
}

.org-policy-img {
	height: 210px;
	border-radius: 8px;
	object-fit: contain;
}

.org-policy-arrow {
	background-image: url('@/assets/images/home/icon4.png');
	background-size: 100% 100%;
	border: none;
	width: 45px;
	height: 35px;
	cursor: pointer;
}


.arrow-left {
	transform: rotate(-90deg);
}

.arrow-right {
	transform: rotate(90deg);
}

/* 专业能力评价等级 */
.certificate-box {
	background-image: url('@/assets/images/home/bg-2.png');
	background-size: 100% 100%;
	padding-bottom: 80px;
}

.certificate-mian {
	width: var(--main-width);
	margin-top: 40px;
	margin: 0 auto;
}

.certificate-list {
	display: flex;
	justify-content: space-between;
	gap: 32px;
}

.certificate-item {
	background: #fff;
	border-radius: 16px;
	padding: 0 20px;
	flex: 1;
	min-width: 320px;
	/* box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08); */
	display: flex;
	flex-direction: column;
	align-items: center;
}

.certificate-info {
	display: flex;
	gap: 18px;
	margin-bottom: 18px;
}

.certificate-icon {
	width: 40px;
}

.certificate-texts {
	display: flex;
	justify-content: space-around;
	flex-direction: column;
	color: #333333;
	font-size: 16px;
	gap: 4px;
}

.certificate-level {
	font-weight: bold;
	font-size: 18px;
	color: #1A53B0;
}

.certificate-img {
	height: 160px;
	object-fit: contain;
	border-radius: 8px;
	margin: 0px 0 8px 0;
	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.10);
}

.certificate-sample {
	color: #3E3E3E;
	font-size: 13px;
	margin-top: 2px;
}

/* 测试流程样式 */
.test-process-container {
	margin: 0px auto 0 auto;
	width: var(--main-width);
	padding-bottom: 75px;
}

.test-tabs {
	display: flex;
	justify-content: space-around;
	align-items: center;
	border-radius: 12px;
	font-weight: bold;
}

.test-tab {
	background-image: url('@/assets/images/home/btn-ash.png');
	background-repeat: no-repeat;
	color: #fff;
	background-size: 100% 100%;
	border-radius: 12px;
	width: 232px;
	text-align: center;
	height: 45px;
	line-height: 45px;
	cursor: pointer;
	filter: brightness(1.2) opacity(0.8);
}

.test-tab.active {
	background-image: url('@/assets/images/home/btn-bg.png');
	z-index: 2;
	filter: brightness(1) opacity(1);
}

.test-tab-subtitle {
	text-align: center;
	font-size: 16px;
	color: #3D3D3D;
	margin-bottom: 18px;
	display: flex;
	justify-content: space-around;
	margin-top: 10px;
}

.test-tab-subtitle span {
	width: 232px;
	display: inline-block;
	text-align: center;
}

.test-tab-content {
	width: 100%;
	margin: 20px auto auto auto;
}

.test-tab-steps {
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	padding-top: 30px;
	margin-top: -45px;
	position: relative;
}

.test-tab-steps::before {
	content: '';
	border-top: 1px dashed #7D7D7D;
	position: absolute;
	width: 100%;
	width: 950px;
	/* top: 75px; */
}

.test-step {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 43px;
	z-index: 1;
	padding-top: 24px
}

.test-step-circle {
	width: 47px;
	height: 47px;
	border-radius: 50%;
	background: #fff;
	font-size: 15px;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 7px;
}

.test-step-circle img {
	width: 100%;
	height: 100%;
}

.test-step-label {
	color: #333333;
	font-size: 16px;
	/* font-weight: bold; */
}

.test-step-arrow {
	width: 15px;
	height: 15px;
	margin: 23px 0px;
	vertical-align: middle;
	z-index: 2;
	transform: rotate(180deg);
}

.test-tab-panels {
	display: flex;
	flex-direction: row;
	padding: 45px 70px;
	gap: 30px;
	justify-content: center;
}

.test-panel {
	background: #fff;
	border-radius: 16px;
	padding: 20px;
	flex: 1;
	min-width: 500px;
	max-width: 650px;
	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);

}

.test-panel-left {
	margin-right: 32px;
}

.test-panel-title {
	font-size: 18px;
	font-weight: bold;
	color: #222;
	margin-bottom: 8px;
	position: relative;
	padding-left: 18px;
}


.test-panel-content {
	font-size: 16px;
	color: #444;
	width: 100%;
}

.test-subject {
	line-height: 1.5;
	position: relative;
}

.test-panel-img {
	display: flex;
	margin-top: 15px;
	align-items: center;
	justify-content: flex-start;
}

.test-books-img {
	width: 200px;
	margin-right: 15px;
	position: absolute;
	right: 0;
	top: 30px;
}

.intermediate .test-books-img {
	right: 30px;
	top: 110px;
	width: 250px;
}

/* 教材简介样式 */
.textbook-introduction {
	background: #fff;
	border-radius: 12px;
	margin: 0 auto;
	width: var(--main-width);
	padding: 0px 0 45px 0;
}

.textbook-item {
	display: flex;
	align-items: center;
	border-radius: 12px;
	margin-bottom: 32px;
	padding: 24px 32px;
	gap: 32px;
}

.textbook-item:nth-child(odd) {
	background: #EDF4FB;
}

.textbook-item:nth-child(even) {
	background: #F9F8F8;
}

.textbook-img {
	height: 200px;
	object-fit: contain;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.10);
}

.textbook-info {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	border-radius: 8px;
}

.textbook-title {
	font-size: 22px;
	font-weight: bold;
	color: #1B74CC;
	margin-bottom: 16px;
}

.textbook-desc {
	font-size: 14px;
	color: #444;
	line-height: 2;
}

.test-process {
	border-radius: 16px;
	margin: 0px auto 0 auto;
	padding: 45px 0 0px 0;
	position: relative;
	background-image: url('@/assets/images/home/bg-3.png');
	background-size: 100% 100%;
}

.fixed {
	position: fixed;
	top: 210px;
	right: 0;
	width: 65px;
	background: #fff;
	border-radius: 15px;
	display: flex;
	flex-direction: column;
	text-align: center;
	justify-content: space-evenly;
	cursor: pointer;
	z-index: 99999;
	padding: 15px 0 15px 0;
}

.fixed img {
	width: 37px;
	height: 37px;
	margin-bottom: 3px;
}

.fixed p {
	margin: 0;
	font-size: 12px;
	text-align: center;
	line-height: 18px;
	color: #000;
}

#popup {
	width: 224px;
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
	color: #FFFFFF;
	text-align: center;
	border-radius: 15px;
	padding: 15px 30px;
	position: fixed;
	top: 210px;
	right: -380px;
	z-index: 8888;
	transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);
	display: block;
}

#popup.popup-visible {
	right: 50px;
}

.products-content-ph {
	width: 100%;
}

.products-content-right-btn {
	height: 60.5px;
	margin: 0 auto;
	border-radius: 50px;
	font-size: 15px;
	/* font-weight: 700; */
	color: #0076F6;
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	line-height: 1.5;
}

.custom-tooltip-mask {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.15);
	z-index: 99999;
	display: flex;
	align-items: center;
	justify-content: center;
}

.custom-tooltip-content {
	background: #fff;
	color: #222;
	border-radius: 12px;
	box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.18);
	padding: 36px 48px;
	max-width: 600px;
	min-width: 420px;
	font-size: 16px;
	line-height: 2;
	position: relative;
}

.floatinz-window {
	position: fixed;
	bottom: -4px;
	left: 0;
	width: 100%;
	z-index: 99;
	cursor: pointer;
}

.floatinz-window-container {
	width: 100%;
	display: inline-block;
	position: relative;
}

.floatinz-close {
	position: absolute;
	top: 4px;
	right: 3px;
	z-index: 99;
	cursor: pointer;
}

.floatinz-close img {
	width: 20px !important;
}

.floatinz-window img {
	width: 100%;
}
</style>